import { PAYMENT_METHODS, platforms } from '../../constants/app';
import { COUNTRY_SHORT_NAMES } from '../../constants/country';

export const redirectToExclusiveOffer = (query: URLSearchParams): void => {
  window.location.replace(`${window.location.origin}/vip-journey-mode?${query}`);
};

export const isRTL = (direction: string): boolean => direction === 'rtl';

export const isProd = (): boolean => process.env.REACT_APP_ENV?.toUpperCase() === 'PROD';

export const getPaymentMethod = (dcbUrl: string | null, platform: string | null): string => {
  let paymentMethod = '';
  if (dcbUrl) {
    paymentMethod = PAYMENT_METHODS.dcb;
  } else {
    paymentMethod =
      platform === platforms.ios || platform === platforms.iosX ? PAYMENT_METHODS.applepay : PAYMENT_METHODS.googlepay;
  }

  return paymentMethod;
};

export const getDCB_URL = (
  platform: string | null,
  language: string | null,
  userId: string | null,
  mcc: string | null,
  mnc: string | null,
  layout_type: string | null,
  country?: string
): string => {
  const rootURL =
    platform === platforms.android || !!layout_type
      ? `${process.env.REACT_APP_WEB_PAGE_URL}/v3/fresh`
      : process.env.REACT_APP_WEB_PAGE_URL;

  const layoutType = layout_type ? `?layout_type=${layout_type}` : '';

  return `${rootURL}/inappredirect/${language}/${country || COUNTRY_SHORT_NAMES.AE}/${mcc ?? '0'}/${
    mnc ?? '0'
  }/${userId}${layoutType}`;
};
